import { render, staticRenderFns } from "./TableAttachment.vue?vue&type=template&id=5009e3bd&scoped=true&"
import script from "./TableAttachment.vue?vue&type=script&lang=js&"
export * from "./TableAttachment.vue?vue&type=script&lang=js&"
import style0 from "./TableAttachment.vue?vue&type=style&index=0&id=5009e3bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009e3bd",
  null
  
)

export default component.exports